import { memo } from 'react';
import { Box, Icon, Text } from '@bonanza-social/moonlight';
import { CommunityJackpotRewardCardProps } from './CommunityJackpotRewardCard.types';
import CommunityJackpotCard from '../../CommunityJackpotCard/CommunityJackpotCard';
import { formatNumber } from '@bonanza-social/toolkit/utils';

function CommunityJackpotRewardCard({
  amount,
  ...rest
}: CommunityJackpotRewardCardProps) {
  const icon = (
    <Icon
      name="bonanzaCoin"
      gradient="accentBackground"
      width="space-500"
      height="space-500"
    />
  );

  return (
    <CommunityJackpotCard {...rest}>
      <Text variant="h1" gradient="darkSurfaceAccent" textAlign="center">
        {formatNumber(amount)}
      </Text>
      <Box flexDirection="row" gap="space-400" centerContent>
        {icon}
        <Text
          variant="callout"
          gradient="darkSurfaceAccent"
          locKey="bonanzaCoins"
          locNS="communityJackpot"
        />
        {icon}
      </Box>
    </CommunityJackpotCard>
  );
}

export default memo(CommunityJackpotRewardCard);
